import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";
import { Box } from "@mui/system";
import { ThemeProvider } from "@mui/material/styles";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Checkbox, FormControl, TextField } from "@mui/material";
import { FaPencilAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import {
  getMuiTheme,
  selectStyles,
  StripedDataGrid,
  textBoxStyles,
} from "../../Visits/ConfigureNavigations";
import DialogBox from "../../../../../components/DialogBox";
import { useCallbackPrompt } from "../../../../../hooks/useCallbackPrompt";
import {
  createNewBussinessRuleService,
  getAllBusinessRulesDataService,
} from "./BusinessRules";
import { requestFailed } from "../../Visits/CreateVisit";

const BusinessRules = () => {
  const [loading, setLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [showPrompt, confirmNavigation, cancelNavigation] =
    useCallbackPrompt(showDialog);
  const navigate = useNavigate();
  const [pageSize, setPageSize] = useState(5);
  const [businessData, setBusinessData] = useState([]);

  const createBusinessRuleSchema = yup.object().shape({
    name: yup
      .string()
      .trim()
      .required("Rule is required")
      .matches(
        /^[A-Za-z][A-Za-z0-9\s!@#$%^&*()_+=-]*$/,
        "Rule must start with a letter and cannot start with a number or special character"
      ),
    description: yup
      .string()
      .trim()
      .required("Description is required")
      .matches(
        /^[A-Za-z][A-Za-z0-9\s!@#$%^&*()_+=-]*$/,
        "Description must start with a letter and cannot start with a number or special character"
      ),
    inclusive: yup.bool().oneOf([true, false]),
  });

  const {
    register,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(createBusinessRuleSchema),
  });

  const notify = () =>
    toast.success("Business Rule Added Successfully", {
      toastId: "form-creation",
    });

  useEffect(() => {
    getBusinessData();
  }, []);

  const columns = [
    // {
    //   field: "id",
    //   hide: true,
    //   headerName: "ID",
    //   width: 0,
    //   renderHeader: () => <div className="grid-heading-id">{"ID"}</div>,
    //   renderCell: (params) => {
    //     const id = params.row.id;

    //     return (
    //       <div className="grid-id">
    //         <p>{id}</p>
    //       </div>
    //     );
    //   },
    // },
    {
      field: "name",
      // hide: true,
      headerName: "Name",
      width: 180,
      renderHeader: () => <div className="grid-heading">{"Name"}</div>,
      renderCell: (params) => {
        const name = params.row.name;

        return (
          <div className="grid-body">
            <p>{name}</p>
          </div>
        );
      },
    },
    {
      field: "description",
      // hide: true,
      headerName: "Description",
      width: 290,
      renderHeader: () => <div className="grid-heading">{"Description"}</div>,
      renderCell: (params) => {
        const description = params.row.description;

        return (
          <div className="grid-body">
            <p>{description}</p>
          </div>
        );
      },
    },
    {
      field: "operatorType",
      // hide: true,
      headerName: "Operator Type",
      width: 180,
      // filterable: false,
      valueGetter: (params) =>
        params.row.businessRuleDetails?.[0]?.businessRuleOperatorType?.name ||
        "",
      renderHeader: () => <div className="grid-heading">{""}</div>,
      renderCell: (params) => {
        const operatorType =
          params.row.businessRuleDetails[0]?.businessRuleOperatorType?.name;

        return (
          <div className="grid-body">
            <p>{params.value}</p>
          </div>
        );
      },
    },
    {
      field: "edit",
      // hide: true,
      headerName: "Edit",
      filterable: false,
      renderHeader: () => <div className="grid-heading">{"Edit"}</div>,
      width: 120,
      renderCell: (params) => {
        const id = params.row.id;

        return (
          <button
            onClick={() => {
              navigate("/study-management/edit-business-rules", {
                state: {
                  id: id,
                },
              });
            }}
            style={{
              cursor: "pointer",
              textAlign: "center",
              backgroundColor: "#337ab7",
              border: "none",
              borderRadius: "5px",
              padding: "10px 10px",
            }}
          >
            <FaPencilAlt
              color="white"
              style={{
                fontSize: "15px",
              }}
            />
          </button>
        );
      },
    },
  ];

  const handleBack = (e) => {
    e.preventDefault();
    if (showDialog) {
      const confirm = window?.confirm(
        "You have unsaved changes,Are you sure want to leave ?"
      );
      if (confirm) {
        navigate("/study-management");
      } else {
        e.preventDefault();
      }
    } else {
      navigate("/study-management");
    }
  };

  const getBusinessData = async () => {
    setLoading(true);
    try {
      const res = await getAllBusinessRulesDataService();
      if (res?.status) {
        setLoading(false);
        setBusinessData(res?.data?.result);
      }
    } catch (err) {
      setLoading(false);
      console.log("Error: ", err?.message);
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    console.log(data);
    try {
      const res = await createNewBussinessRuleService(data);
      if (res?.status) {
        setLoading(false);
        notify();
        reset();
        getBusinessData();
      }
    } catch (err) {
      setLoading(false);
      requestFailed(err?.message);
      reset();
      console.log("Error: ", err?.message);
    }
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
          }}
        >
          <BeatLoader color="#3661eb" />
        </div>
      ) : (
        <div className="content-body">
          <p className="study-management-link" style={{ fontWeight: "600" }}>
            <div
              onClick={(e) => {
                handleBack(e);
              }}
            >
              <Link>Manage Your Study</Link>
            </div>{" "}
            |{" "}
            <Link to="/study-management/business-rules">
              Manage Business Rules
            </Link>
            -{" "}
            <b style={{ color: "gray" }}>
              {sessionStorage?.getItem("studyName")}
            </b>
          </p>
          <Row style={{ marginTop: "2%", marginBottom: "2%" }}>
            <Col md={12}>
              <div className="study-management-head-start">
                <p className="study-management-heading">
                  Manage Business Rules
                </p>
              </div>
            </Col>
          </Row>
          <div>
            <DialogBox
              showDialog={showPrompt}
              confirmNavigation={confirmNavigation}
              cancelNavigation={cancelNavigation}
            />
          </div>

          <Row>
            <Col md={8} sm={12}>
              <Box sx={{ height: 400, width: "100%", display: "flex" }}>
                <ThemeProvider theme={getMuiTheme}>
                  <StripedDataGrid
                    className="allQuestionnaire-grid"
                    rows={businessData}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[5, 10, 20]}
                    // components={{ Toolbar: GridToolbar }}
                    pagination
                    rowHeight={38}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "even"
                        : "odd"
                    }
                  />
                </ThemeProvider>
              </Box>
            </Col>
            <Col md={4} sm={12}>
              <Box
                component="form"
                onSubmit={handleSubmit(onSubmit)}
                autoComplete="off"
                sx={{
                  border: "1px solid rgb(224 224 224)",
                  borderRadius: "5px",
                  padding: "20px",
                  minheight: "500px",
                  maxHeight: "550px",
                }}
              >
                <h4>Add New Rule</h4>
                <div style={{ marginTop: "30px" }}>
                  <h5 style={{ fontWeight: "bold" }}>
                    New Rule
                    <span className="error-highlight">*</span>
                  </h5>
                  <FormControl sx={selectStyles}>
                    <TextField
                      type={"text"}
                      inputProps={{
                        style: textBoxStyles,
                      }}
                      {...register("name", {
                        onChange: (e) => {
                          setShowDialog(true);
                        },
                      })}
                    />
                  </FormControl>
                </div>
                {errors.name && (
                  <>
                    <div style={{ marginTop: "30px" }}>
                      <div className="createVisitError">
                        <span
                          className="error-text"
                          style={{
                            color: "red",
                            textTransform: "none",
                            display: "inline-block",
                            wordWrap: "break-word",
                            maxWidth: "300px",
                          }}
                        >
                          {errors.name.message}
                        </span>
                      </div>
                    </div>
                  </>
                )}
                <div style={{ marginTop: "30px" }}>
                  <h5 style={{ fontWeight: "bold" }}>
                    Description
                    <span className="error-highlight">*</span>
                  </h5>
                  <FormControl sx={selectStyles}>
                    <TextField
                      type={"text"}
                      rows={2}
                      multiline
                      inputProps={{
                        style: textBoxStyles,
                      }}
                      {...register("description", {
                        onChange: (e) => {
                          setShowDialog(true);
                        },
                      })}
                    />
                  </FormControl>
                </div>
                {errors.description && (
                  <>
                    <div style={{ marginTop: "30px" }}>
                      <div className="createVisitError">
                        <span
                          className="error-text"
                          style={{
                            color: "red",
                            textTransform: "none",
                            display: "inline-block",
                            wordWrap: "break-word",
                            maxWidth: "300px",
                          }}
                        >
                          {errors.description.message}
                        </span>
                      </div>
                    </div>
                  </>
                )}

                <Row style={{ marginTop: "30px" }}>
                  <Col md={8}>
                    <label
                      id="inclusive"
                      className="descriptionLabel"
                      style={{ paddingTop: "8px" }}
                    >
                      Include all details for true value:{" "}
                    </label>
                  </Col>
                  <Col md={4}>
                    <Checkbox
                      name="inclusive"
                      sx={{
                        "& .MuiSvgIcon-root": { fontSize: 22 },
                      }}
                      inputProps={{ "aria-label": "controlled" }}
                      {...register("inclusive", {
                        onChange: (e) => {
                          setShowDialog(true);
                        },
                      })}
                    />
                    {errors.inclusive && (
                      <>
                        <div className="createCaregiverFlexEnd">
                          <div className="createCaregiverError">
                            <span className="error-text">
                              {errors.inclusive.message}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                  </Col>
                </Row>

                <div style={{ marginTop: "30px", textAlign: "center" }}>
                  <button
                    type="submit"
                    style={{
                      cursor: "pointer",
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#337ab7",
                      padding: "8px 17px",
                      fontSize: "15px",
                      border: "none",
                      borderRadius: "5px",
                    }}
                  >
                    Add New Rule
                  </button>
                </div>
              </Box>
            </Col>
          </Row>

          <Row style={{ marginTop: "2%" }}>
            <Col md={6}></Col>
            <Col md={6}>
              {/* <Link to="/study-management/visits"> */}
              <div className="study-management-head-end">
                <button
                  className="study-management-create-btn-lg"
                  onClick={(e) => {
                    handleBack(e);
                  }}
                >
                  Back
                </button>
              </div>
              {/* </Link> */}
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};

export default BusinessRules;
